import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
	onAddReply,
	onUpdateFeedbacks,
} from '../../redux/feedback/feedback.action'
import {
	formatDateTime,
	showMessageError,
	showMessageSuccess,
} from '../../utils/function.utils'
import { ButtonCommon } from '../ButtonCommon/ButtonCommon'
import RadioButtonCommon from '../RadioButtonCommon/RadioButtonCommon'
import { TableCommon } from '../TableCommon/TableCommon'
import { TextAreaCommon } from '../TextAreaCommon/TextAreaCommon'
import './ReplyListCommon.scss'
const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
	},
	{
		title: 'Content',
		dataIndex: 'content',
		key: 'content',
	},
	{
		title: 'Auth Email',
		dataIndex: ['user', 'authEmail'],
		key: 'authEmail',
	},
]
const ReplyListComponent = ({
	feedback,
	onAddReply,
	setModalVisible,
	onUpdateFeedbacks,
}) => {
	const [optionSelected, setOptionSelected] = useState(null)
	const [isAdd, setIsAdd] = useState(false)
	const [input, setInput] = useState('')
	const [isSubmitLoading, setIsSubmitLoading] = useState()

	useEffect(() => {
		setOptionSelected(feedback?.status)
	}, [feedback])

	const pagination = {
		total: feedback?.replies?.length,
		pageSize: 5,
		position: 'topLeft',
	}

	const options = [
		{ label: 'Show', value: 'show' },
		{ label: 'Hidden', value: 'new' },
	]

	const addClick = () => {
		setIsAdd(true)
	}

	const rowKey = record => {
		return record.id
	}

	const closeClick = () => {
		setIsAdd(false)
	}

	const replyClick = () => {
		setIsSubmitLoading(true)
		onAddReply(
			{ feedbackID: feedback.id, content: input },
			onAddReplyCallback
		)
	}

	const onInputChange = value => {
		setInput(value)
	}

	const onAddReplyCallback = (isSuccess, rs) => {
		setIsSubmitLoading(false)

		if (isSuccess) {
			setIsAdd(false)
			showMessageSuccess('Send successfully')
		} else {
			showMessageError(rs)
		}
	}
	const onOptionChange = e => {
		setOptionSelected(e.target.value)
	}

	const onSaveCick = () => {
		onUpdateFeedbacks(
			{ ...feedback, status: optionSelected },
			onUpdateFeedbacksCallback
		)
	}

	const onUpdateFeedbacksCallback = isSuccess => {
		if (isSuccess) {
			setModalVisible(false)
		} else {
			showMessageError()
		}
	}

	return (
		<div className="reply-list-wrap">
			<RadioButtonCommon
				label={'Show Or Hiden'}
				options={options}
				onChange={onOptionChange}
				value={optionSelected}
			/>
			<div className="content">
				<ul>
					<li>
						<div className="label">Email - name</div>
						<div className="data highlight">
							{feedback?.email} - {feedback?.name}
						</div>
					</li>
					<li>
						<div className="label">Created at</div>
						<div className="data">
							{formatDateTime(feedback?.createdAt)}
						</div>
					</li>
					<li>
						<div className="label">Content</div>
						<div className="data highlight text">
							{feedback?.content}
						</div>
					</li>
					<li>
						<div className="label">Source</div>
						<div className="data">{feedback?.createdBy}</div>
					</li>
					<li>
						<div className="label">More info</div>
						<div className="data">
							{feedback?.moreInfo &&
								JSON.stringify(feedback?.moreInfo)}
						</div>
					</li>
				</ul>
			</div>
			<div className="reply-list">
				<div className="reply-list-top">
					<div className="u-title reply-title">Replies</div>
					<div>
						<span>Total:</span>&nbsp;
						<strong>{feedback?.replies?.length}</strong>
					</div>
					<div className="reply-list-top-right">
						{!isAdd ? (
							<ButtonCommon type="primary" onClick={addClick}>
								Add
							</ButtonCommon>
						) : (
							<>
								<TextAreaCommon onChange={onInputChange} />
								<div style={{ display: 'flex', gap: '1rem' }}>
									<ButtonCommon
										type="primary"
										onClick={replyClick}
										loading={isSubmitLoading}
									>
										Reply
									</ButtonCommon>
									<ButtonCommon onClick={closeClick}>
										Close
									</ButtonCommon>
								</div>
							</>
						)}
					</div>
				</div>
				<TableCommon
					rowKey={rowKey}
					columns={columns}
					dataSource={feedback.replies}
					pagination={pagination}
				/>
				<div className="feedback-save-button">
					<ButtonCommon onClick={onSaveCick}>Save</ButtonCommon>
				</div>
			</div>
		</div>
	)
}

ReplyListComponent.propTypes = {
	feedback: PropTypes.any,
	onAddReply: PropTypes.any,
	setModalVisible: PropTypes.any,
	onUpdateFeedbacks: PropTypes.any,
}

const mapStateToProps = state => ({
	feedback: state.feedback.selectedFeedback,
})
export const ReplyListCommon = connect(mapStateToProps, {
	onAddReply,
	onUpdateFeedbacks,
})(ReplyListComponent)
// export default ReplyListCommon;
